import React from 'react';
import { observer } from 'mobx-react';
import LoginComponent from './Login.component';
import useLogin from './useLogin';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, user, lang, handlers } = useLogin(onClose);
    
    return (
        <>
            <LoginComponent
                loading={user.loading}
                authError={user.authError}
                lang={lang.lang}
                login={state.login}
                password={state.password}
                loginError={state.loginError}
                passwordError={state.passwordError}
                registerError={user.registerError}
                serverError={user.serverError}
                onLoginChange={handlers.handleLoginChange}
                onPasswordChange={handlers.handlePasswordChange}
                onSignInClick={handlers.handleSignInClick}
                onInputClick={handlers.handleInputClick}
                onRegisterOpen={handlers.handleRegisterOpen}
                onPassRecoveryOpen={handlers.handlePassRecoveryOpen}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onKeyDown={handlers.handleKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const LoginContainer = observer(Container);

export default LoginContainer;
